import { render, staticRenderFns } from "./CargaPosRow.vue?vue&type=template&id=3bf8e360&scoped=true&"
import script from "./CargaPosRow.vue?vue&type=script&lang=js&"
export * from "./CargaPosRow.vue?vue&type=script&lang=js&"
import style0 from "./CargaPosRow.vue?vue&type=style&index=0&id=3bf8e360&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf8e360",
  null
  
)

export default component.exports